var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogleLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF4831",
    fillRule: "evenodd",
    d: "M8 3.093c1.502 0 2.516.65 3.093 1.191l2.258-2.204C11.964.791 10.16 0 8 0 6.517 0 5.063.412 3.8 1.19 2.54 1.97 1.519 3.083.854 4.41L3.44 6.418C4.089 4.488 5.884 3.093 8 3.093zm7.68 5.085c0-.658-.053-1.138-.169-1.636H8v2.97h4.409c-.089.737-.569 1.848-1.636 2.595l2.525 1.955c1.51-1.395 2.382-3.449 2.382-5.884z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF4831",
    fillRule: "evenodd",
    d: "M3.449 9.582c-.175-.51-.265-1.044-.267-1.582 0-.551.098-1.084.258-1.582L.853 4.408C.293 5.523.001 6.753 0 8c0 1.289.311 2.507.853 3.591L3.45 9.582h-.001z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF4831",
    fillRule: "evenodd",
    d: "M8 16c2.16 0 3.973-.711 5.298-1.938l-2.525-1.955c-.675.47-1.582.8-2.773.8-2.116 0-3.911-1.396-4.551-3.325l-2.587 2.01C2.178 14.203 4.872 16 8 16z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google_logo.64cc25b6.svg";
export { ForwardRef as ReactComponent };